import StytchLogin from '../components/StytchLogin';

const Login = () => {
  return (
    <StytchLogin />
  );
};

export default Login;